import React, { useEffect, useState, useContext } from 'react'
// import logo from './logo.svg';
// import './App.css';
import GetRoute from './router/index'
import intl from 'react-intl-universal'
import { LanguageContext } from './contexts/LanguageContext'
import { Session } from './contexts/Session'
import { HospitalBasicInfoContext } from './contexts/HospitalBasicInfo'
import { OrderMarkContext } from './contexts/OrderMark'
import request from './utils/request'
import { Toast, Modal } from 'antd-mobile'
import objSort from './utils/objSort'
import deepCopy from './utils/deepCopy'
import config from './config'
import {
  getOssClient,
  getAllFoodType,
  getPatientInfo
} from './components/Order/OrderFunction'
const locales = {
  'en-US': require('./locales/en-US.json'),
  'zh-CN': require('./locales/zh-CN.json')
}
// const OSS = require('ali-oss')
function App () {
  const [initDone, setInitDone] = useState(false)
  const Language = useContext(LanguageContext)
  const SessionContext = useContext(Session)
  const HospitalBasicInfo = useContext(HospitalBasicInfoContext)
  const sdxHisCode = window.localStorage.getItem('sdxHisCode')
  const [currentUser, setCurrentUser] = useState({})
  const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId')
  const OrderMark = useContext(OrderMarkContext)
  const sdxUUID = window.localStorage.getItem('sdxUUID')

  const [ifUUID, setIfUUID] = useState(window.location.href.indexOf('index') >= 0) // uuid是否过期
  // useEffect(() => {
  //   const language = {
  //     en: 'en-US',
  //     zh: 'zh-CN'
  //   }
  //   intl.init({
  //     // currentLocale: 'en-US',
  //     // currentLocale: languageContext.locale,
  //     currentLocale: language[Language.locale],
  //     locales
  //   }).then(() => {
  //     setInitDone(true)
  //   })
  //   console.log('app.js language')
  // }, [Language])

  useEffect(() => {
    window.onerror = function (message, source, lineno, colno, error) {
      var string = message.toLowerCase();
      var substring = "script error";
      if (string.indexOf(substring) > -1){
        alert('Script Error: See Browser Console for Detail');
      } else {
        collectionException(message, source, lineno, colno, error)
      }
      return false;
    };
  }, [])

  useEffect(() => {
    document.getElementById('cspContent').content = config.content
  }, [])
  useEffect(() => {
    document.title = Language.locale === 'en' ? 'U e+ Meal Ordering System' : '优e+订餐系统'
  }, [Language.locale])

  useEffect(() => {
    if (window.localStorage.getItem('sdxUserToken')) {
      if (OrderMark.ossClient === '' && sdxUUID) {
        getOssClient(OrderMark, Language)
      }
      getAllFoodType(OrderMark, Language)
    }
    // eslint-disable-next-line
  }, [SessionContext.tokenExist, Language.acceptLanguage])

  useEffect(() => {
    const tmpHospitalInfo = HospitalBasicInfo.hospitalBasicInfo
    if (tmpHospitalInfo && tmpHospitalInfo.basicHospitalInfo) {
      const tmpMealTypes = tmpHospitalInfo.basicHospitalInfo.mealtypes
      const afterSortMealTypes = tmpMealTypes.length > 0 ? tmpMealTypes.sort(objSort('sort')) : []
      OrderMark.setMealtypes(afterSortMealTypes)
      const properties = tmpHospitalInfo.basicHospitalInfo.properties
      OrderMark.setProperties(properties) // 获取是否支持包伙制
      window.sessionStorage.setItem('properties', JSON.stringify(properties))
    }
    // eslint-disable-next-line
  }, [HospitalBasicInfo.hospitalBasicInfo])

  useEffect(() => {
    const language = {
      en: 'en-US',
      zh: 'zh-CN'
    }
    intl.init({
      // currentLocale: 'en-US',
      // currentLocale: languageContext.locale,
      currentLocale: language[Language.locale] || language.zh,
      locales
    }).then(() => {
      setInitDone(true)
    })
    if (SessionContext.currentUser.language) {
      // if (Language.locale !== SessionContext.currentUser.language) {
      const sdxUserToken = window.localStorage.getItem('sdxUserToken')
      // const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId')
      // console.log(window.localStorage)
      if (sdxUserToken && sdxUUID) {
        // console.log('app.js')
        request('/v1/orderers', {
          method: 'GET',
          headers: {
            'Accept-Language': Language.acceptLanguage
          }
        }).then((res) => {
          if (!res.error) {
            if (res.data.language) {
              if (res.data.language !== Language.locale) {
                Language.setLocale(res.data.language)
              }
            }
            if (window.localStorage.getItem('sdxUserToken')) {
              setCurrentUser(res.data)
              SessionContext.setCurrentUser(res.data)
              SessionContext.setLogged(true)
              if (res.data.patientDTO === null) {
                SessionContext.setBinded(false)
              } else {
                SessionContext.setBinded(true)
              }
            } else {
              SessionContext.setCurrentUser({})
              SessionContext.setLogged(false)
              SessionContext.setBinded(false)
            }
          } else {
            // Toast.info(res.message)
            SessionContext.setLogged(false)
            SessionContext.setBinded(false)
            window.localStorage.removeItem('sdxUserToken')
            const defaultLanguage = navigator.language || navigator.userLanguage
            Language.setLocale(defaultLanguage.substring(0, 2))
            SessionContext.setCurrentUser({})
            // if (window.localStorage.getItem('sdxTokens')) {
            //   const sdxTokens = JSON.parse(window.localStorage.getItem('sdxTokens'))
            //   sdxTokens[sdxHisCode] = undefined
            //   window.localStorage.setItem('sdxTokens', JSON.stringify(sdxTokens))
            // }
            // Toast.info('获取当前登录人信息失败!')
            if (res.message === 'invalid_token') {
              Toast.info('旧帐号已过期，请重新注册!')
              SessionContext.setLogged(false)
              SessionContext.setBinded(false)
              window.localStorage.removeItem('sdxUserToken')
              const defaultLanguage = navigator.language || navigator.userLanguage
              Language.setLocale(defaultLanguage.substring(0, 2))
              SessionContext.setCurrentUser({})
            }
          }
        }).catch((error) => {
          console.log(error)
        })
        // 请求营养餐的所有类型
        // console.log('获取营养餐和小锅菜的类型，情况1')
        // getAllFoodType(OrderMark, Language)
      }

      /**
           * 不论用户是点击公众号进入的系统还是扫描床头二维码进入的系统，都能获取到医院的hisCode
           * 根据hisCode去获取医院的基本信息以及配置信息
           */
      if (sdxHisCode && sdxUUID) {
        request(`/v1/hospitals/${sdxHisCode}`, {
          method: 'GET',
          headers: {
            'Accept-Language': Language.acceptLanguage
          }
        }).then((res) => {
          // console.log(res)
          if (!res.error) {
            if (res.data === null) {
              Toast.info('获取医院配置信息为空')
            }
            // res.data.properties.isSupportEditPatient = false
            const basicHospitalInfo = deepCopy(res.data)
            getFoodAdvicesByHisCode(basicHospitalInfo)
          } else {
            const codeArr = ['1001']
            if (codeArr.includes(res.code)) {
              // Toast.info(res.message)
            } else if (res.code === '2000') {
              if (window.location.href.indexOf('index') === -1) {
                redirectToAuth()
              } else {
                setIfUUID(true)
                // console.log('现在在首页，跳转逻辑由index.js处理')
              }
            } else {
              console.log(res)
            }
            // Toast.info(res.message)
            // Toast.info('获取医院配置信息失败')
          }
        }).catch((error) => {
          console.log(error)
        })
      }
      // }
    } else {
      const sdxUserToken = window.localStorage.getItem('sdxUserToken')
      // const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId')
      // console.log(window.localStorage)
      if (sdxUserToken && sdxUUID) {
        // console.log('app.js')
        request('/v1/orderers', {
          method: 'GET',
          headers: {
            'Accept-Language': Language.acceptLanguage
          }
        }).then((res) => {
          if (!res.error) {
            if (res.data.language) {
              if (res.data.language !== Language.locale) {
                Language.setLocale(res.data.language)
              }
            }
            setCurrentUser(res.data)
            if (window.localStorage.getItem('sdxUserToken')) {
              SessionContext.setCurrentUser(res.data)
              SessionContext.setLogged(true)
              if (res.data.patientDTO === null) {
                SessionContext.setBinded(false)
              } else {
                SessionContext.setBinded(true)
              }
            } else {
              SessionContext.setCurrentUser({})
              SessionContext.setLogged(false)
              SessionContext.setBinded(false)
            }
          } else {
            // Toast.info(res.message)
            SessionContext.setLogged(false)
            SessionContext.setBinded(false)
            window.localStorage.removeItem('sdxUserToken')
            const defaultLanguage = navigator.language || navigator.userLanguage
            Language.setLocale(defaultLanguage.substring(0, 2))
            SessionContext.setCurrentUser({})
            // if (window.localStorage.getItem('sdxTokens')) {
            //   const sdxTokens = JSON.parse(window.localStorage.getItem('sdxTokens'))
            //   sdxTokens[sdxHisCode] = undefined
            //   window.localStorage.setItem('sdxTokens', JSON.stringify(sdxTokens))
            // }
            // Toast.info('获取当前登录人信息失败!')
            if (res.message === 'invalid_token') {
              Toast.info('旧帐号已过期，请重新注册!')
              SessionContext.setLogged(false)
              SessionContext.setBinded(false)
              window.localStorage.removeItem('sdxUserToken')
              const defaultLanguage = navigator.language || navigator.userLanguage
              Language.setLocale(defaultLanguage.substring(0, 2))
              SessionContext.setCurrentUser({})
            }
          }
        }).catch((error) => {
          console.log(error)
        })
        // 请求营养餐和小锅菜的所有类型
        // console.log('获取营养餐和小锅菜的类型情况2')
        // getAllFoodType(OrderMark, Language)
      }

      /**
       * 不论用户是点击公众号进入的系统还是扫描床头二维码进入的系统，都能获取到医院的hisCode
       * 根据hisCode去获取医院的基本信息以及配置信息
       */
      if (sdxHisCode && sdxUUID) {
        request(`/v1/hospitals/${sdxHisCode}`, {
          method: 'GET',
          headers: {
            'Accept-Language': Language.acceptLanguage
          }
        }).then((res) => {
          // console.log(res)
          if (!res.error) {
            if (res.data === null) {
              Toast.info('获取医院配置信息为空')
            }
            // res.data.properties.isSupportEditPatient = false
            const basicHospitalInfo = deepCopy(res.data)
            getFoodAdvicesByHisCode(basicHospitalInfo)
          } else {
            // Toast.info(res.message)
            // Toast.info('获取医院配置信息失败')
            const codeArr = ['1001']
            if (codeArr.includes(res.code)) {
              // Toast.info(res.message)
            } else if (res.code === '2000') {
              if (window.location.href.indexOf('index') === -1) {
                redirectToAuth()
              } else {
                setIfUUID(true)
                // console.log('现在在首页,跳转逻辑由index.js处理')
              }
            } else {
              console.log(res)
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    }
    // eslint-disable-next-line
  }, [Language.acceptLanguage, SessionContext.codeExist, SessionContext.tokenExist])

  /**
   * 收集js代码异常
   */
  function collectionException (message, source, lineno, colno, error) {
    const hisCode = window.localStorage.getItem('sdxHisCode')
    const FormData = require('form-data')
    const form = new FormData()
    form.append('message', message)
    form.append('source', source)
    form.append('linenoRow', lineno)
    form.append('colnoRow', colno)
    form.append('error', JSON.stringify(error))
    form.append('userAgent', navigator.userAgent)
    form.append('hisCode', hisCode)
    fetch(`${config.server}/v1/wxcommons/oauth2/webErrorLog`, {
      method: 'POST',
      body: form,
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    })
  }

  /**
   * 重定向到微信授权页面
   */
  function redirectToAuth () {
    const hisCode = window.localStorage.getItem('sdxHisCode') ? window.localStorage.getItem('sdxHisCode') : ''
    const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId') ? `/${window.localStorage.getItem('sdxPatPositionId')}` : ''
    const indexUrl = `/index/${hisCode}${sdxPatPositionId}`
    Toast.info(
      intl.get('RedirectToAuth'), 2,
      () => {
        window.location.replace(`${config.server}/v1/wxcommons/oauth2?return_url=%23${indexUrl}`)
        // window.location.replace(`${config.server}/v1/wxcommons/oauth2?return_url=${indexUrl}`)
      }, true)
  }

  useEffect(() => {
    // 对浏览器的UserAgent进行正则匹配，不含有微信独有标识的则为其他浏览器（微信独有标识为：MicroMessenger/版本号）
    // 微信内置浏览器useragent.match(/MicroMessenger/i) === 'MicroMessenger'（object类型）
    // 非微信内置浏览器useragent.match(/MicroMessenger/i) === null
    var useragent = navigator.userAgent
    if (!useragent.match(/MicroMessenger/i)) {
      // 这里警告框会阻塞当前页面继续加载
      const title = Language.locale === 'en' ? 'Error' : '错误'
      const content = Language.locale === 'en'
        ? `This visit has been banned: you must use the built-in Wechat browser to access this page. (Please scan or enter from the hospital's WeChat Official Account).`
        : '已禁止本次访问：您必须使用微信内置浏览器访问本页面（微信扫一扫或从医院公众号进入）！'
      Modal.alert(title, content, [{
        text: Language.locale === 'en' ? 'OK' : '确定',
        onPress: () => {
          var opened = window.open('about:blank', '_self')
          opened.opener = null
          opened.close()
        },
        style: {}
      }], 'IOS')
      return () => {}
    // 以下代码是用javascript强行关闭当前页面
    }
    // eslint-disable-next-line
  }, [sdxHisCode])

  // 获取床位号 + 饮食医嘱 + 病人的姓名
  useEffect(() => {
    const currentUser = SessionContext.currentUser
    const patientDTO = currentUser.patientDTO
    if (patientDTO && JSON.stringify(patientDTO) !== '{}') {
      // console.log('获取病人床位号+饮食医嘱+姓名')
      getPatientInfo(OrderMark, SessionContext)
    }
    // console.log(SessionContext)
    // eslint-disable-next-line
  }, [SessionContext.currentUser])

  useEffect(() => {
    if (currentUser.patientDTO) {
      // getSTSInfo(OrderInfo, Language)
    }
  }, [currentUser])

  useEffect(() => {
    function fetchData () {
      if (sdxPatPositionId) {
        getAreasFloorsInfoByPatientBedId()
        getPatientInfoByPatientBedId()
      } else {
        if (SessionContext.patientInfo.length !== 0) {
          SessionContext.setPatientInfo([])
        }
        if (JSON.stringify(SessionContext.positionInfo) !== '{}') {
          SessionContext.setPositionInfo({})
        }
      }
    }
    fetchData()
    // eslint-disable-next-line
  }, [SessionContext.codeExist, Language.acceptLanguage])

  /**
   * 根据医院的hisCode去获取医院所有的饮食医嘱
   */
  function getFoodAdvicesByHisCode (basicHospitalInfo) {
    request(`/v1/foodadvices/hospital/${sdxHisCode}`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      if (res && !res.error) {
        setIfUUID(true)
        if (res.data.length > 0) {
          const basicInfoTemp = {}
          basicInfoTemp.basicHospitalInfo = basicHospitalInfo
          basicInfoTemp.foodAdvices = res.data
          HospitalBasicInfo.setHospitalBasicInfo(basicInfoTemp)
          // getAreasByHisCode(basicHospitalInfo, res.data)
        } else {
          const basicInfoTemp = {}
          basicInfoTemp.basicHospitalInfo = basicHospitalInfo
          basicInfoTemp.foodAdvices = res.data
          HospitalBasicInfo.setHospitalBasicInfo(basicInfoTemp)
          // Toast.info('获取医院饮食医嘱为空!')
        }
      } else {
        console.log(res.message)
        // Toast.info(res.message)
        // Toast.info('获取医院饮食医嘱失败!')
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 当用户扫描床头二维码进入时，根据床位号获取病员信息
   */
  function getPatientInfoByPatientBedId () {
    const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId')
    request(`/v1/patients/patposition/${sdxPatPositionId}?hospitalId=${sdxHisCode}`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        if (!res.data) {
          // Toast.info('根据床位号获取病员信息为空!')
          SessionContext.setPatientInfo([])
        } else {
          SessionContext.setPatientInfo(res.data)
        }
      } else {
        if (res.code) {
          SessionContext.setPatientInfo([])
          if (Number(res.code) === 1001) {
            // setShowModal(true)
            // Toast.info(intl.get('QueryPetientInfo1001'))
            // Toast.info(res.message)
          } else if (Number(res.code) === 1002) {
            // setShowModal(true)
            // Toast.info(intl.get('QueryPetientInfo1002'))
            // Toast.info(res.message)
          } else if (Number(res.code) === 1003) {
            // setShowModal(true)
            // Toast.info(intl.get('QueryPetientInfo1003'))
            // Toast.info(res.message)
          } else {
            console.log(res.message)
          }
        } else {
          console.log(res.message)
        }
        // Toast.info(res.message)
        // Toast.info('根据床位号获取病员信息失败!')
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 根据床位号获取病区，楼层信息
   */
  function getAreasFloorsInfoByPatientBedId () {
    const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId')
    request(`/v1/hospitals/${sdxHisCode}/lc/bq/patposition/${sdxPatPositionId}`, {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        if (!res.data) {
          // Toast.info('根据床位号获取病区，楼层信息为空!')
          SessionContext.setPositionInfo({})
        } else {
          SessionContext.setPositionInfo(res.data)
        }
      } else {
        console.log(res.message)
        // Toast.info(res.message)
        // Toast.info('根据床位号获取病区，楼层信息失败!')
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  return (ifUUID && initDone && <GetRoute />)
}

export default App
